import { env } from "@/env";

/**
 * Polling intervals for periodic transaction requests.
 * These intervals match the backend cache TTLs to ensure efficient data fetching.
 * When throttling is enabled (NEXT_PUBLIC_THROTTLE_1CLICK_DB_REQUESTS === "true"),
 * longer intervals are used to reduce load.
 */

// Backend cache TTLs (in seconds)
export const TRANSACTIONS_CACHE_TTL_SECONDS =
	env.NEXT_PUBLIC_THROTTLE_1CLICK_DB_REQUESTS === "true"
		? 3 * 60 // 3 minutes when throttled
		: 10; // 10 seconds

export const TRANSACTIONS_BY_IDS_CACHE_TTL_SECONDS =
	env.NEXT_PUBLIC_THROTTLE_1CLICK_DB_REQUESTS === "true"
		? 3 * 60 // 3 minutes when throttled
		: 10; // 10 seconds

export const TRANSACTION_BY_DEPOSIT_ADDRESS_CACHE_TTL_SECONDS =
	env.NEXT_PUBLIC_THROTTLE_1CLICK_DB_REQUESTS === "true"
		? 60 // 1 minute when throttled
		: 5; // 5 seconds

// Frontend polling intervals (in milliseconds) - derived from backend TTLs
export const TRANSACTIONS_POLLING_INTERVAL_MS =
	TRANSACTIONS_CACHE_TTL_SECONDS * 1000;

export const TRANSACTIONS_BY_IDS_POLLING_INTERVAL_MS =
	TRANSACTIONS_BY_IDS_CACHE_TTL_SECONDS * 1000;

export const TRANSACTION_BY_DEPOSIT_ADDRESS_POLLING_INTERVAL_MS =
	TRANSACTION_BY_DEPOSIT_ADDRESS_CACHE_TTL_SECONDS * 1000;
